import { useTranslation } from '@/i18n';
import {
  ButtonV2,
  IconButton,
  IconDownload,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback, useState } from 'react';

type Props = {
  onClick: () => Promise<void>;
  isDisabled?: boolean;
  tooltipTitle?: string;
  variant?: 'icon' | 'text';
  className?: string;
};

export const DownloadButton: FC<Props> = memo(
  ({
    onClick: _onClick,
    isDisabled,
    tooltipTitle,
    variant = 'icon',
    className,
  }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);

    const onClick = useCallback(async () => {
      setIsLoading(true);
      try {
        await _onClick();
      } finally {
        setIsLoading(false);
      }
    }, [_onClick]);

    const button =
      variant === 'text' ? (
        <ButtonV2
          size='xs'
          isSecondary
          isTransparent
          onClick={onClick}
          isDisabled={isDisabled}
          isLoading={isLoading}
          className={className}
        >
          {t('import_export_history_error_detail_download')}
        </ButtonV2>
      ) : (
        <IconButton
          size='xs'
          onClick={onClick}
          isLoading={isLoading}
          isDisabled={isDisabled}
          color='primary'
          inVisible
        >
          <IconDownload size={16} />
        </IconButton>
      );

    return isDisabled && tooltipTitle ? (
      <Tooltip title={tooltipTitle}>
        <span>{button}</span>
      </Tooltip>
    ) : (
      button
    );
  }
);

DownloadButton.displayName = 'DownloadButton';
